import React, {useEffect, useMemo, useState} from 'react';
import {SuccessLogo} from '../../UI/Icons';
import styled from 'styled-components';
import {MediumTitle, primaryGreenBtn} from '../../mixins';
import {selectEventsData, /*selectFBPurchaseData,*/selectOfferType, setPaymentStatus, setShowPaywall} from '../onboarding/onboardingSlice';
import {useDispatch, useSelector} from 'react-redux';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import {sendRevenueCatRequest} from '../../analytics/revenueCat';
import {setMetrics} from '../../analytics/eCommerce';
import {selectDiscountAmount, selectID, selectPlan, selectUpsellData, selectStripeNonce, selectUpsellPlan, selectFinalPrice} from './paywallSlice';
import {selectUserID, selectEmail, selectRegistrationSource} from '../auth/authSlice';
import PaywallModal from '../../UI/PaywallModal';
import UpsellPopup from './UpsellPopup';
import {selectUserInfo} from '../login/loginSlice';


const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 300px;
  margin-top: auto;
  margin-bottom: auto;
`;
const Title = styled.h1`
  ${MediumTitle}
`;

const StyledButton = styled.button`
  ${primaryGreenBtn};
  background-color: #FBA253;
  width: 327px;
  border: none;
`;

const StyledPriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  
  p {
    ${MediumTitle};
  }
`;


const SuccessScreen = () => {
    const dispatch = useDispatch();
    const plan = useSelector(selectPlan);
    const orderID = useSelector(selectID);
    const userID = useSelector(selectUserID);
    const finalPrice = useSelector(selectFinalPrice);
    const discount = useSelector(selectDiscountAmount);
    const amplitudeEventData = useSelector(selectEventsData);
    const offerType = useSelector(selectOfferType);
    const upsellData = useSelector(selectUpsellData);
    const stripeNonce = useSelector(selectStripeNonce);
    const userInfo = useSelector(selectUserInfo);
    const registrationSource = useSelector(selectRegistrationSource);
    const authEmail = useSelector(selectEmail);
    const [upsellShow, setUpsellShow] = useState(false);
    const [sendEvents, setSendEvents] = useState(false);
    const eventId = `${stripeNonce}_${userID || userInfo.id}`;
    const email = registrationSource === 'email' ? (authEmail || userInfo.email) : '';
    const displayUpsellFor = useMemo(() => ['up'], []);
    const upsellPlan = useSelector(selectUpsellPlan);

    useEffect(() => {
        if (
            displayUpsellFor.includes(offerType) &&
            amplitudeEventData.payment_method !== 'Paypal' &&
            upsellPlan !== ''
        ) {
            setTimeout(() => setUpsellShow(true), 500);
            setSendEvents(true);
        }
    }, [offerType, displayUpsellFor, upsellPlan, amplitudeEventData.payment_method]);

    useEffect(() => {
        upsellData && upsellData.success && setUpsellShow(false);
    }, [upsellData?.success]);

    useEffect(() => sendAnalyticsEvents(EVENTS.successScreenShown, amplitudeEventData), []);

    useEffect(() => {
        if (orderID && userID) {
            sendRevenueCatRequest(orderID, userID);
        }
    }, [orderID, userID]);

    useEffect(() => {
        if (sendEvents && plan && orderID) {
            const gclid = amplitudeEventData?.gclid || '';
            setMetrics(plan, orderID, finalPrice, upsellData?.success, offerType, eventId, email, gclid);
        }
    }, [sendEvents, plan, orderID, finalPrice, upsellData, offerType, eventId, email, amplitudeEventData]);


    const onStartClick = () => {
        dispatch(setPaymentStatus(true));
        dispatch(setShowPaywall(false));
    };

    const onUpsellClose = () => {
        setUpsellShow(false);
        setSendEvents(true);
    };

    const title = finalPrice ? 'Congrats! You have been granted a discount on your first payment.' : 'Your plan awaits!';


    return (
        <StyledContainer>
            {SuccessLogo}
            <Title>{title}</Title>
            {finalPrice && (
                <StyledPriceBlock>
                    <p>{`Discount amount: - ${discount || ''}%`}</p>
                    <p>{`Total: ${finalPrice || ''} USD`}</p>
                </StyledPriceBlock>
            )}

            <StyledButton onClick={onStartClick} id='continue-button'>Start Tracking</StyledButton>
            <PaywallModal show={upsellShow} onClose={onUpsellClose}>
                <UpsellPopup onContinueCb={() => setSendEvents(true)} closePopup={() => setUpsellShow(false)} upsellPlan={upsellPlan}/>
            </PaywallModal>
            <input type='hidden' id={'end-of-onboarding'} />
        </StyledContainer>
    );
};


export default SuccessScreen;